import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ComingSoonBackSoonTransformer } from './coming-soon-back-soon.transformer';

import { ApiComingSoonBackSoonRequestBody } from '@api/_api/api-coming-soon-back-soon/api-coming-soon-back-soon.models';
import { ApiComingSoonBackSoonService } from '@api/_api/api-coming-soon-back-soon/api-coming-soon-back-soon.service';
import { EcommerceContext } from '@core/domain/models/context.models';
import { getContext } from '@core/infrastructure/state/core.selectors';
import { routerPublicQueries } from '@frontend/libs/duttirouter';
import { SubscribeComingSoonBackSoonErrorAnalytics } from '@shared/analytics/store/app-events-analytics.actions';

/**
 * Servicio para la suscripción en ComingSoon / BackSoon
 */

@Injectable()
export class ComingSoonBackSoonService {
    // private product$: Observable<ProductPublicModels.PublicProduct>;
    private paramsFromRouter$: Observable<Params>;

    private context$: Observable<EcommerceContext>;

    constructor(
        private readonly store: Store,
        private readonly apiComingSoonBackSoonService: ApiComingSoonBackSoonService
    ) { }

    // Esto debería convertirse en un side effect
    // eslint-disable-next-line no-secrets/no-secrets
    /**
     * Suscribe a un usuario a una o varias newsletters.
     * @param request el objeto con la información del usuario y las newsletters a las que se quiere suscribir.
     * public subscribeEmailNewsletter(storeId: string, languageId: string,
     * body: ApiNewsletterRequestBody): Observable<ApiEmptyResponse>
     */
    public subscribeTocomingSoonBackSoon(productId: string, request: ApiComingSoonBackSoonRequestBody) {
        this.paramsFromRouter$ = this.store.select(routerPublicQueries.getParamsFromRouter);
        this.context$ = this.store.select(getContext);

        const apiRequest = ComingSoonBackSoonTransformer.comingSoonBackSoonBodyToApi(request);

        return combineLatest([this.paramsFromRouter$, this.context$]).pipe(
            map(([paramsFromRouter, context]) => {
                return {
                    productId,
                    categoryId: paramsFromRouter.categoryId || 0,
                    context,
                };
            }),
            switchMap((resp) =>
                this.apiComingSoonBackSoonService.subscribeComingSoonBackSoon(
                    resp.context.store.id,
                    resp.context.currentLanguage.id,
                    apiRequest,
                    resp.context.currentCatalog.id,
                    resp.categoryId,
                    resp.productId
                ).pipe(
                    catchError((error) => {
                        this.store.dispatch(SubscribeComingSoonBackSoonErrorAnalytics({ error }));
                        return of(false);
                    })
                )),
            map(() => [])
        );
    }

    //
}
